import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPolicyByEnum, getPolicyTypes, resetPolicies, resetPolicyDetails } from '../store/reducer/legalSlice';

const useLegal = ({ shouldFetchTypes = true }) => {
  const dispatch = useDispatch();
  const { policyTypesList, policyDetails } = useSelector((state) => state?.legal);

  const [isLoading, setLoading] = useState(false);

  const [isFetchingPolicy, setFetchingPolicy] = useState(true);

  async function fetchPolicyTypes() {
    try {
      setLoading(true);
      await dispatch(getPolicyTypes());
    } catch (error) {
      // eslint-disable-next-line
      console.log({ error });
    } finally {
      setLoading(false);
    }
  }

  async function fetchPolicyByEnum(title) {
    try {
      setFetchingPolicy(true);
      await dispatch(resetPolicyDetails());
      await dispatch(getPolicyByEnum(title));
    } catch (error) {
      // eslint-disable-next-line
      console.log({ error });
    } finally {
      setFetchingPolicy(false);
    }
  }

  useEffect(() => {
    if (shouldFetchTypes) fetchPolicyTypes();
  }, []);

  useEffect(() => {
    return async () => {
      await dispatch(resetPolicies());
      await dispatch(resetPolicyDetails());
    };
  }, []);

  return {
    isLoading,
    policyTypesList,
    policyDetails: policyDetails ?? null,
    fetchPolicyByEnum,
    isFetchingPolicy,
  };
};

export default useLegal;
